/**
 * Created by Administrator on 2018/1/12 0012.
 * store 公共方法类
 */

// 导入公共状态模块

const getters = {

  /**
   * 配置文件
   * @param state
   * @return {*}
   */
  config (state) {
    return state.config
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js